"use strict";

$(function () {
  $(".carousel.carousel-offset").each(function () {
    const carousel = $(this);
    const items = carousel.find(".item");
    const section = carousel.closest("section");
    const prevBtn = section.find(".carousel-button-prev");
    const nextBtn = section.find(".carousel-button-next");

    let currentIndex = 0;

    function getMaxIndex() {
      const isMobile = $(window).width() < 768;
      if (isMobile) {
        return items.length - 1;
      }
      const itemWidth = items.first().outerWidth(true);
      const visibleWidth =
        $(window).width() - (parseFloat(carousel.css("margin-left")) || 0);
      return Math.max(
        0,
        Math.ceil((items.length * itemWidth - visibleWidth) / itemWidth),
      );
    }

    function moveCarousel(direction) {
      const itemWidth = items.first().outerWidth(true);
      const maxIndex = getMaxIndex();

      if (direction === "next" && currentIndex < maxIndex) {
        currentIndex++;
      } else if (direction === "prev" && currentIndex > 0) {
        currentIndex--;
      }

      carousel.css("transform", `translateX(-${currentIndex * itemWidth}px)`);
    }

    prevBtn.on("click", function (e) {
      e.preventDefault();
      moveCarousel("prev");
    });

    nextBtn.on("click", function (e) {
      e.preventDefault();
      moveCarousel("next");
    });

    // Swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    carousel.on("touchstart", function (e) {
      touchStartX = e.originalEvent.touches[0].clientX;
      touchEndX = touchStartX;
    });

    carousel.on("touchmove", function (e) {
      touchEndX = e.originalEvent.touches[0].clientX;
    });

    carousel.on("touchend", function (e) {
      const deltaX = touchEndX - touchStartX;
      const swipeThreshold = 50;

      if (Math.abs(deltaX) > swipeThreshold) {
        if (deltaX > 0) {
          moveCarousel("prev"); // Swipe right
        } else {
          moveCarousel("next"); // Swipe left
        }
      }
    });
  });
});
